import { Toast } from 'vant'
// import LoadingBar from 'nprogress'
//
// LoadingBar.configure({ showSpinner: false })

export const toast = {
  success (message, duration = 2000) {
    Toast({
      type: 'success',
      message,
      duration
    })
  },
  error (message, duration = 2000) {
    Toast({
      type: 'error',
      message,
      duration
    })
  },
  warning (message, duration = 2000) {
    Toast({
      type: 'warning',
      message,
      duration
    })
  },
  loading (duration = 0) {
    Toast.loading({
      message: '加载中...',
      forbidClick: true
    })
  },
  close () {
    Toast.clear()
  }
}

export const loading = {
  open () {
    // LoadingBar.start()
  },
  close () {
    // LoadingBar.done()
  },
  error () {
    // LoadingBar.error()
  },
  progress (percent) {
    // LoadingBar.set(percent)
  }
}
export default {
  toast,
  loading
}
